import type { AttributionCookie } from '../attribution-manager/script';

declare global {
	interface Window {
		AttributionManagerLinks?: AttributionManagerLinks;
	}
}

/**
 * AttributionManagerLinks class.
 *
 * Imports AttributionManager, and appends attribution to HTML links.
 */
class AttributionManagerLinks {
	constructor() {
		// Init and update external links when attribution changes.
		this.appendAttributionToExternalLinks();
		window.addEventListener('AttributionManager:update', () => {
			this.appendAttributionToExternalLinks();
		});
	}

	appendAttributionToExternalLinks() {
		if (!window.AttributionManager) return;

		const attributionParams: AttributionCookie = window.AttributionManager.getData();

		if (!attributionParams) return;

		const currentDomain = window.location.hostname;
		const links = document.querySelectorAll<HTMLAnchorElement>('a');

		links.forEach((link) => {
			const href = link.getAttribute('href');
			if (
				!href ||
				href.startsWith('#') ||
				href.startsWith('mailto:') ||
				href.startsWith('tel:')
			) {
				return;
			}

			const url = new URL(href, window.location.origin);

			if (url.hostname !== currentDomain) {
				const newQueryParams = new URLSearchParams(url.search);
				Object.entries(attributionParams).forEach(([key, value]) => {
					const keyLower = key.toLowerCase();
					if (!newQueryParams.has(keyLower) && typeof value === 'string') {
						newQueryParams.append(keyLower, value);
					}
				});

				url.search = newQueryParams.toString();
				link.href = url.toString();
			}
		});
	}
}

// Added to window to allow you to do window.AttributionManagerLinks.appendAttributionToExternalLinks() within code elsewhere in project.
window.AttributionManagerLinks = new AttributionManagerLinks();
